const TOKEN_KEY = 'blaster_token';
const USER_KEY = 'blaster_user';

export const authUtils = {
  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },
  
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },
  
  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  
  setUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  
  getUser: () => {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  },
  
  getAuthHeader: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  // NEW: Role-based functions
  hasRole: (allowedRoles) => {
    const user = authUtils.getUser();
    return user && allowedRoles.includes(user.role);
  },

  isSuperAdmin: () => {
    return authUtils.hasRole(['super_admin']);
  },

  isSPV: () => {
    return authUtils.hasRole(['spv']);
  },

  isOperator: () => {
    return authUtils.hasRole(['operator']);
  },

  canAccessTracking: () => {
    return authUtils.hasRole(['super_admin', 'spv']);
  },

  canManageUsers: () => {
    return authUtils.hasRole(['super_admin', 'spv']);
  },

  canUpload: () => {
    return authUtils.hasRole(['super_admin', 'spv']);
  },

  getUserRole: () => {
    const user = authUtils.getUser();
    return user ? user.role : null;
  },

  getUserBrand: () => {
    const user = authUtils.getUser();
    return user ? user.brand : null;
  },

  getSPVInfo: () => {
    const user = authUtils.getUser();
    return user ? {
      spv_id: user.spv_id,
      spv_username: user.spv_username,
      spv_name: user.spv_name
    } : null;
  }
};